<template>
    <button :class="{ 'isWhite': colorMode === 'white' }" @click="$emit('actionButton')">
        <p>{{ label }}</p>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M5.14286 0H16.7143C17.4244 0 18 0.575634 18 1.28571V12.8571C18 13.5672 17.4244 14.1429 16.7143 14.1429C16.0042 14.1429 15.4286 13.5672 15.4286 12.8571V4.3897L2.19485 17.6234C1.69275 18.1255 0.87868 18.1255 0.376577 17.6234C-0.125526 17.1213 -0.125526 16.3073 0.376577 15.8051L13.6103 2.57143H5.14286C4.43278 2.57143 3.85714 1.99579 3.85714 1.28571C3.85714 0.575634 4.43278 0 5.14286 0Z" />
        </svg>
    </button>
</template>

<script>
export default {
    name: 'botonSpecial',
    data() {
        return {
        }
    },
    components: {

    },
    props: {
        label: {
            type: String,
            default: 'default'
        },
        colorMode: {
            type: String,
            default: 'default'
        }
    }
}
</script>

<style scoped>
.isWhite {
    background-color: #fff !important;
}

.isWhite p {
    color: #B359F8 !important;
    transition: color 300ms;
}

.isWhite:hover {
    background-color: #cec9e0 !important;

    background: linear-gradient(90deg, #fff 0%, #fff 20%, #96FF11 40%, #FFE711 60%, #4536EF 80%, #FF00B8 100%);
    background-position: 0% 0%;
    background-size: 500%;

}
.isWhite svg{
    fill: #B359F8 !important;
}
.isWhite:hover p{
    color: #fff !important;
}
.isWhite:hover svg{
    fill: #fff !important;
}

button {
    display: flex;
    width: 19.652778vw;
    height: 4.166667vw;
    padding: 1.388889vw 1.388889vw;
    align-items: center;
    justify-content: space-between;
    border: .069444vw solid #ffffff00;
    border-radius: 34.722222vw;
    transition: border 2s ease, background-color 2s ease;
    animation: hoverMiniOut 2s;
    background-color: #B359F8;
    clip-path: polygon(0% 50%, 0% 50%, 0.139% 41.89%, 0.54% 34.196%, 1.183% 27.022%, 2.045% 20.471%, 3.105% 14.645%, 4.34% 9.647%, 5.729% 5.581%, 7.25% 2.549%, 8.881% 0.654%, 10.601% 0%, 66.784% 0%, 66.784% 0%, 67.846% 0.248%, 68.878% 0.975%, 69.875% 2.158%, 70.831% 3.773%, 71.743% 5.797%, 72.605% 8.206%, 73.412% 10.977%, 74.16% 14.085%, 74.842% 17.508%, 75.454% 21.221%, 75.454% 21.221%, 75.649% 22.423%, 75.863% 23.545%, 76.094% 24.577%, 76.341% 25.507%, 76.603% 26.325%, 76.879% 27.018%, 77.167% 27.577%, 77.466% 27.99%, 77.774% 28.246%, 78.092% 28.333%, 78.092% 28.333%, 78.409% 28.246%, 78.718% 27.99%, 79.017% 27.577%, 79.305% 27.018%, 79.581% 26.325%, 79.843% 25.507%, 80.09% 24.577%, 80.321% 23.545%, 80.535% 22.423%, 80.73% 21.221%, 80.73% 21.221%, 81.342% 17.508%, 82.024% 14.085%, 82.771% 10.977%, 83.578% 8.206%, 84.44% 5.797%, 85.352% 3.773%, 86.309% 2.158%, 87.306% 0.975%, 88.338% 0.248%, 89.399% 0%, 89.399% 0%, 91.119% 0.654%, 92.75% 2.549%, 94.271% 5.581%, 95.66% 9.647%, 96.895% 14.645%, 97.955% 20.471%, 98.817% 27.022%, 99.46% 34.196%, 99.861% 41.89%, 100% 50%, 100% 50%, 99.861% 58.11%, 99.46% 65.804%, 98.817% 72.978%, 97.955% 79.529%, 96.895% 85.355%, 95.66% 90.353%, 94.271% 94.419%, 92.75% 97.451%, 91.119% 99.346%, 89.399% 100%, 89.399% 100%, 88.338% 99.752%, 87.306% 99.025%, 86.309% 97.842%, 85.352% 96.227%, 84.44% 94.203%, 83.578% 91.794%, 82.771% 89.023%, 82.024% 85.915%, 81.342% 82.492%, 80.73% 78.779%, 80.73% 78.779%, 80.535% 77.577%, 80.321% 76.455%, 80.09% 75.423%, 79.843% 74.493%, 79.581% 73.675%, 79.305% 72.982%, 79.017% 72.423%, 78.718% 72.01%, 78.409% 71.754%, 78.092% 71.667%, 78.092% 71.667%, 77.774% 71.754%, 77.466% 72.01%, 77.167% 72.423%, 76.879% 72.982%, 76.603% 73.675%, 76.341% 74.493%, 76.094% 75.423%, 75.863% 76.455%, 75.649% 77.577%, 75.454% 78.779%, 75.454% 78.779%, 74.842% 82.492%, 74.16% 85.915%, 73.412% 89.023%, 72.605% 91.794%, 71.743% 94.203%, 70.831% 96.227%, 69.875% 97.842%, 68.878% 99.025%, 67.846% 99.752%, 66.784% 100%, 10.601% 100%, 10.601% 100%, 8.881% 99.346%, 7.25% 97.451%, 5.729% 94.419%, 4.34% 90.353%, 3.105% 85.355%, 2.045% 79.529%, 1.183% 72.978%, 0.54% 65.804%, 0.139% 58.11%, 0% 50%);
}

button p {
    color: var(--White, #FFF);
    font-family: "SharpGrotesk-Medium25";
    font-size: 1.25vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: .1375vw;
    text-transform: uppercase;
    width: 12.5vw;

}

button svg {
    width: 1.25vw;
    height: 1.25vw;
    fill: #fff;
    transition: transform 400ms 1.3s ease, fill 400ms 0s ease;
    transform: rotate(0deg);

}

button:hover {
    background: linear-gradient(90deg, #B359F8 0%, #B359F8 20%, #96FF11 40%, #FFE711 60%, #4536EF 80%, #FF00B8 100%);
    background-position: 0% 0%;
    background-size: 500%;
    animation: hoverMini 2s 1 both;
    border: .069444vw solid #97979700;
    background-color: #9907c5;
}

button:hover svg {
    /* animation: hoverMiniIcon 2s ease 1 both; */
    transform: rotate(45deg);
    fill: #fff;
}

@keyframes hoverMiniIcon {
    0% {
        transform: rotate(0deg);

    }

    25% {
        transform: rotate(0deg);
        fill: #ffffff;

    }

    65% {
        transform: rotate(0deg);
        fill: #ffffff;

    }

    100% {
        transform: rotate(45deg);
        fill: #ffffff;

    }
}

@keyframes hoverMini {
    0% {
        background-position: 1% 0%;
    }

    35% {
        background-position: 45% 0%;
    }

    65% {
        background-position: 45% 0%;
    }

    100% {
        background-position: 99% 0%;
    }
}

@keyframes hoverMiniIconOut {

    0% {
        transform: rotate(45deg);
        fill: #ffffff;

    }

    100% {
        transform: rotate(0deg);

    }


}

@keyframes hoverMiniOut {
    0% {
        background-position: 99% 0%;
    }

    100% {
        background-position: 1% 0%;
    }
}

@media (max-width: 530px) {
    button {
        aspect-ratio: 360 / 60;
        width: 100%;
        height: auto;

        padding: 4.186047vw 5.348837vw;
        clip-path: polygon(0% 50%, 0% 50%, 0.109% 41.89%, 0.425% 34.196%, 0.93% 27.022%, 1.608% 20.471%, 2.441% 14.645%, 3.412% 9.647%, 4.504% 5.581%, 5.699% 2.549%, 6.982% 0.654%, 8.333% 0%, 74.167% 0%, 74.167% 0%, 74.998% 0.245%, 75.805% 0.966%, 76.586% 2.139%, 77.335% 3.741%, 78.05% 5.748%, 78.725% 8.137%, 79.358% 10.886%, 79.944% 13.97%, 80.48% 17.366%, 80.962% 21.052%, 80.962% 21.052%, 81.086% 22.013%, 81.222% 22.906%, 81.369% 23.723%, 81.527% 24.457%, 81.694% 25.1%, 81.869% 25.643%, 82.052% 26.079%, 82.242% 26.4%, 82.438% 26.599%, 82.639% 26.667%, 82.639% 26.667%, 82.84% 26.599%, 83.035% 26.4%, 83.225% 26.079%, 83.409% 25.643%, 83.584% 25.1%, 83.751% 24.457%, 83.909% 23.723%, 84.056% 22.906%, 84.192% 22.013%, 84.316% 21.052%, 84.316% 21.052%, 84.797% 17.366%, 85.333% 13.97%, 85.92% 10.886%, 86.553% 8.137%, 87.228% 5.748%, 87.943% 3.741%, 88.692% 2.139%, 89.473% 0.966%, 90.28% 0.245%, 91.111% 0%, 91.667% 0%, 91.667% 0%, 93.018% 0.654%, 94.301% 2.549%, 95.496% 5.581%, 96.588% 9.647%, 97.559% 14.645%, 98.392% 20.471%, 99.07% 27.022%, 99.575% 34.196%, 99.891% 41.89%, 100% 50%, 100% 50%, 99.891% 58.11%, 99.575% 65.804%, 99.07% 72.978%, 98.392% 79.529%, 97.559% 85.355%, 96.588% 90.353%, 95.496% 94.419%, 94.301% 97.451%, 93.018% 99.346%, 91.667% 100%, 91.111% 100%, 91.111% 100%, 90.28% 99.755%, 89.473% 99.034%, 88.692% 97.861%, 87.943% 96.259%, 87.228% 94.252%, 86.553% 91.863%, 85.92% 89.114%, 85.333% 86.03%, 84.797% 82.634%, 84.316% 78.949%, 84.316% 78.949%, 84.192% 77.987%, 84.056% 77.094%, 83.909% 76.277%, 83.751% 75.543%, 83.584% 74.9%, 83.409% 74.357%, 83.225% 73.921%, 83.035% 73.6%, 82.84% 73.401%, 82.639% 73.333%, 82.639% 73.333%, 82.438% 73.401%, 82.242% 73.6%, 82.052% 73.921%, 81.869% 74.357%, 81.694% 74.9%, 81.527% 75.543%, 81.369% 76.277%, 81.222% 77.094%, 81.086% 77.987%, 80.962% 78.949%, 80.962% 78.949%, 80.48% 82.634%, 79.944% 86.03%, 79.358% 89.114%, 78.725% 91.863%, 78.05% 94.252%, 77.335% 96.259%, 76.586% 97.861%, 75.805% 99.034%, 74.998% 99.755%, 74.167% 100%, 8.333% 100%, 8.333% 100%, 6.982% 99.346%, 5.699% 97.451%, 4.504% 94.419%, 3.412% 90.353%, 2.441% 85.355%, 1.608% 79.529%, 0.93% 72.978%, 0.425% 65.804%, 0.109% 58.11%, 0% 50%);
    }

    button p {
        font-size: 4.186047vw;
        transform: translateX(2.325581vw);
        width: 50vw;
        text-align: left;
    }

    button svg {
        height: 4.186047vw;
        width: 4.186047vw;
    }
}
</style>